import { PocTypography } from 'commons/components/components-wrapper';
import styled from 'styled-components';
import { implementModeVariant } from './typography.business';
import { TypographyMode } from './typography.model';

export const TypographyBody1 = styled(PocTypography).attrs<{
    mode?: TypographyMode;
}>(() => ({
    variant: 'body1',
    element: 'h6',
    mode: 'default',
}))`
    ${(props) => props.mode && implementModeVariant(props.mode)}
`;

export const TypographyBody2 = styled(PocTypography).attrs<{
    mode?: TypographyMode;
}>(() => ({
    variant: 'body2',
    element: 'h6',
    mode: 'default',
}))`
    font-size: 14px !important;
    ${(props) => props.mode && implementModeVariant(props.mode)}
`;

export const TypographySubtitle1 = styled(PocTypography).attrs<{
    mode?: TypographyMode;
}>(() => ({
    variant: 'subtitle1',
    element: 'h6',
    mode: 'default',
}))`
    ${(props) => props.mode && implementModeVariant(props.mode)}
`;

export const TypographySubtitle2 = styled(PocTypography).attrs<{
    mode?: TypographyMode;
}>(() => ({
    variant: 'subtitle2',
    element: 'h6',
    mode: 'default',
}))`
    font-size: 14px !important;
    ${(props) => props.mode && implementModeVariant(props.mode)}
`;
